import React, { Component } from 'react';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { LocalForm, Control, combineForms, actions } from 'react-redux-form';
import { ControlLabel, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';

import ImageUpload from '../../common/form/elements/image-upload';
import PageTitle from '../../common/page-title';
import ToastMessage from '../../common/toast-message';
import { convertToFormData } from '../../../utils/commonFunctions';
import irelandApi from '../../../irelandApi';

const TYPES = ['pre_login', 'post_login'];

class EditBackgroundImages extends Component {
  state = { previews: {}, submitting: false };

  constructor(props) {
    super(props);

    this.store = createStore(
      combineForms({ local: {} }),
      applyMiddleware(thunk) // ensures that we can handle thunks dispatched by <ImageUpload/>
    );
  }

  handleSubmit = (values) => {
    const payload = {};

    TYPES.forEach((type) => {
      const value = values[type];
      if (value && typeof value !== 'string') payload[type] = value;
    });

    if (Object.keys(payload).length === 0) return;

    irelandApi.patch(
      '/api/admin/navigation/background',
      convertToFormData('navigation_background', payload),
      { 'content-type': 'multipart/form-data' }
    ).then(() => {
      toast.info(<ToastMessage iconStyle="info" message="Images updated" />);
    }).catch(() => {
      toast.warn(<ToastMessage iconStyle="warning" message="Failed to update images" />);
    }).finally(() => {
      this.setState({ submitting: false });
    });
  }

  componentDidMount() {
    irelandApi.get('/api/admin/navigation/background')
      .then(({ data }) => {
        this.setState({ previews: data });

        Object.entries(data).forEach(([key, url]) => {
          if (url) this.store.dispatch(actions.setValidity(`local.${key}`, true));
        });
      });
  }

  render() {
    const { previews, submitting } = this.state;

    return (
      <LocalForm store={this.store} onSubmit={this.handleSubmit}>
        <PageTitle>Navigation background</PageTitle>

        {TYPES.map(type => (
          <div key={type}>
            <ControlLabel>
              Navigation background image ({type.replace('_', '-')})
            </ControlLabel>

            <ImageUpload
              model={`.${type}`}
              type={['image/jpg', 'image/jpeg', 'image/png']}
              source={previews[type]}
              required
            />
          </div>
        ))}

        <div className="clearfix">
          <Control.custom
            model="local"
            component={Button}
            bsStyle="primary"
            type="submit"
            className="red-ghost-btn float-right"
            mapProps={({ fieldValue: { valid, pristine }}) => ({
              disabled: !valid || pristine
            })}
          >
            {submitting ? 'Saving' : 'Save'}
          </Control.custom>
        </div>
      </LocalForm>
    );
  }
}

export default EditBackgroundImages;



// WEBPACK FOOTER //
// ./src/components/admin/navigation/edit-background-images.jsx